import { Configuration, PublicClientApplication } from '@azure/msal-browser';

import { AZURE_AD } from '../globalConfig';

const msalConfig: Configuration = {
  auth: {
    clientId: AZURE_AD.clientId,
    authority: AZURE_AD.authority,
    postLogoutRedirectUri: '/',
    redirectUri: '/', // Resolve the redirectUri issue
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
export const scopes = ['openid', 'profile', 'User.Read'];

export const getAuthToken = async (): Promise<{
  idToken: string;
  sessionId: string | undefined;
  username: string;
}> => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    try {
      const response = await msalInstance.acquireTokenSilent({
        scopes: [], // empty scope to avoid 401 error
        account: accounts[0],
      });

      return {
        idToken: response.idToken,
        sessionId: response.account.idTokenClaims?.oid,
        username: response.account.username,
      };
    } catch (error) {
      throw new Error('Failed to retrieve token');
    }
  } else {
    throw new Error('No accounts found');
  }
};
